<template>
	<div class="tutorial-thumbnail">
		<div class="tutorial-thumbnail__image"
			:style="{ backgroundImage: `url(${previewUrl})` }">
		</div>
		<div class="tutorial-thumbnail__actions">
			<label class="btn" @click.self="handleImageClick">Upload image
				<input type="file" @change="handleImageChange"
					class="hidden" accept=".gif,.jpg,.jpeg,.png">
			</label>
			<button class="btn" @click="handleImageClear">Remove</button>
		</div>
	</div>
</template>

<script>
	import api from '@/api/tutorial_editor'
	import { mapGetters, mapState } from 'vuex'

	export default {
		name: 'Thumbnail',
		props: ['value'],
		computed: {
			...mapState(['tutorial']),
			...mapGetters(['isNew', 'previewUrl'])
		},
		methods: {
			handleImageClick () {
				if (this.isNew && !this.creatingTutorial) {
					this.creatingTutorial = true
					this.$store.dispatch('createTutorial')
				}
			},
			handleImageChange (event) {
				if (event.target.files.length === 0) return

				let status = { status: 'Uploading thumbnail' }
				this.$store.commit('startLoading', status)

				this.uploadFile(event.target.files).then(data => {
					this.$store.commit('updatePreview', data)
					this.$store.commit('finishLoading', status)
				}).catch(() => {
					this.$store.dispatch('setUploadFailedFlash')
					this.$store.commit('finishLoading', status)
				})
			},
			handleImageClear () {
				this.$store.commit('updatePreview', {id: null, url: ''})
			},
			uploadFile (files) {
				let file = files[0]
				let payload = new FormData()
				payload.append('file', file)
				return api.uploadFile({ id: this.tutorial.id }, payload)
			}
		}
	}
</script>

<style lang="scss">
	@import "@/styles/tutorial_editor/globals";

	.tutorial-thumbnail {
		display: flex;
		.hidden { display: none; }

		&.error &__image {
			border: solid 1px $red;
		}

		&__image {
			width: 256px;
			height: 170px;
			border-radius: 4px;
			background-position: center;
			background-size: cover;
		}

		&__actions {
			margin-left: 20px;
			.btn {
				display: block;
				min-width: 120px;
				margin-bottom: 10px;
			}
		}
	}
</style>
